export default __webpack_public_path__ + "static/media/delhiday.671d4294.jpg";